import React from 'react';
import { X, Download } from 'lucide-react';
import Button from './Button';

const PDFPreview = ({ pdfBlob, onClose, onDownload, filename }) => {
    const [pdfUrl, setPdfUrl] = React.useState(null);

    React.useEffect(() => {
        if (pdfBlob) {
            const url = URL.createObjectURL(pdfBlob);
            setPdfUrl(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [pdfBlob]);

    if (!pdfUrl) return null;

    return (
        <div
            className="pdf-preview-overlay"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem',
                animation: 'fadeIn 0.2s ease-out',
            }}
        >
            <div
                className="pdf-preview-container"
                style={{
                    backgroundColor: 'white',
                    width: '100%',
                    maxWidth: '1200px',
                    height: '95%',
                    borderRadius: 'var(--radius-lg)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)',
                    animation: 'slideUp 0.3s ease-out',
                }}
            >
                <div
                    className="pdf-preview-header"
                    style={{
                        padding: '1rem 1.5rem',
                        borderBottom: '1px solid var(--color-border)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: 'white',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600, color: 'var(--color-text-primary)' }}>
                            Preview: {filename}
                        </h3>
                        <span
                            style={{
                                fontSize: '0.8rem',
                                padding: '0.2rem 0.6rem',
                                backgroundColor: 'var(--color-bg-secondary)',
                                borderRadius: '99px',
                                color: 'var(--color-text-secondary)',
                            }}
                        >
                            {(pdfBlob.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                    </div>
                    <div style={{ display: 'flex', gap: '0.75rem' }}>
                        <Button variant="primary" onClick={onDownload}>
                            <Download size={18} /> Download PDF
                        </Button>
                        <Button variant="ghost" onClick={onClose}>
                            <X size={20} /> Close
                        </Button>
                    </div>
                </div>
                <div
                    className="pdf-preview-content"
                    style={{
                        flex: 1,
                        backgroundColor: '#525659',
                        position: 'relative',
                    }}
                >
                    <iframe
                        src={pdfUrl}
                        title="PDF Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none', display: 'block' }}
                    />
                </div>
            </div>
            <style>{`\n        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }\n      `}</style>
        </div>
    );
};

export default PDFPreview;
